module.exports = __webpack_public_path__ + "static/img/K.2f4aaa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SuperAce/K.png
// module id = cAsP
// module chunks = 0